import { Bold as TiptapBold } from "@tiptap/extension-bold";

import { ActionButton } from "../../components";

export const Bold = TiptapBold.extend({
	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.commands.toggleBold(),
					isActive: () => editor.isActive("bold") || false,
					icon: "Bold",
					shortcutKeys: ["mod", "B"],
					tooltip: t("editor.bold.tooltip")
				}
			})
		};
	}
});
